import { render } from "./LoginMedicos.vue?vue&type=template&id=039c611a&scoped=true"
import script from "./LoginMedicos.vue?vue&type=script&lang=js"
export * from "./LoginMedicos.vue?vue&type=script&lang=js"

import "./LoginMedicos.vue?vue&type=style&index=0&id=039c611a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-039c611a"]])

export default __exports__